module.exports = __webpack_public_path__ + "static/snakehips1-2bb193f5111ac58765217b89a39a8749.jpg";